<div class="container-dash">
  <div class="row-dash">
      <app-dashboard-navbar></app-dashboard-navbar>
      <div class="main">
        <header>
            <div class="card">
                <div class="card-header">
                  Información de perfil
                </div>
                <div class="card-body">
                  <form class="form-post-twitter" [formGroup]="profileForm" (ngSubmit)="submitProfile()">
                    <div class="form-group">
                      <label for="inputUsername">Nombre</label>
                      <input type="search" id="inputUsername" class="form-control" placeholder="Nombre" formControlName="userName">
                    </div>

                    <div class="form-group">
                      <label for="inputCompany">Empresa</label>
                      <input type="search" id="inputCompany" class="form-control" placeholder="Empresa" formControlName="company">
                    </div>

                    <div class="form-group">
                      <label for="inputCountry">País</label>
                      <select id="inputCountry" name="country" class="form-control" placeholder="País" formControlName="country">
                        <option value="Global">Global</option>
                        <option value="Belgium">Belgium</option>
                        <option value="Denmark">Denmark</option>
                        <option value="France">France</option>
                        <option value="Germany">Germany</option>
                        <option value="Spain">Spain</option>
                      </select>
                    </div>
                    <div *ngIf="errorReg" class="alert alert-info" role="alert"> 
                      Error al intentar actualizar el perfil
                    </div>
                    <div *ngIf="updateOk" class="alert alert-success" role="alert"> 
                      Datos actualizados correctamente
                    </div>
                    <br />
                    <button type="submit" id="btnSend" class="btn btn-primary btn-block my-2 my-sm-0">Enviar</button>
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-6 mb-lg-0 mb-5">
                  <!-- <a routerLink="/dashboard/profile" id="linkDiscord" class="btn btn-primary mr-3 mt-3" data-toggle="modal" data-target="#container-model-discord">
                    <span class="icon"><i class="fab fa-discord"></i></span>
                  </a> -->
                     
                
                  <a routerLink="/dashboard/profile" id="linkTwitter" class="btn btn-primary mt-3" data-toggle="modal" data-target="#container-model-twitter">
                    <span class="icon"><i class="fab fa-twitter-square" width="9" height="9"></i></span>
                  </a>
                </div>
              </div>
              <!-- <div class="modal fade" id="container-model-discord" tabindex="-1">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h2 class="modal-title">Discord</h2>
                      <button class="close" data-dismiss="modal">
                        <span>&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <p>You are currently in your discord account. Do you really want to link your account?</p>
                    </div>
                    <div class="modal-footer">
                      <button class="btn btn-outline-dark" data-dismiss="modal">Close</button>
                      <a href= "https://discord.com/api/oauth2/authorize?client_id=851850228939751454&permissions=2147485760&scope=bot" class="btn btn-primary discordbtn">Link</a>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="modal fade" id="container-model-twitter" tabindex="-1">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h2 class="modal-title">Twitter</h2>
                      <button class="close" data-dismiss="modal">
                        <span>&times;</span>
                      </button>
                    </div>
                    <!-- <div class="modal-body">
                      <p>Actualmente estas en tu cuenta de Twitter. Do you really want to link your account?</p>
                    </div> -->
                    <div class="modal-body align-items-center" >
                      <div *ngIf="LoggedTwitter">
                        <p>Cuenta vinculada correctamente</p>
                        <button type="button" (click)="unlinkTwitter()" class="btn btn-primary">Desvincular cuenta</button>
                      </div>
                      <div *ngIf="!LoggedTwitter">
                        <button type="button" (click)="loginTwitter()" class="btn btn-outline-primary">Vincular cuenta</button>
                      </div>
                      <div *ngIf="unlinkError" class="alert alert-danger" role="alert"> 
                        Error al intentar desvincular la cuenta
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
     </div>
  </div>
</div>


<app-footer></app-footer>